import { render } from "./Size.vue?vue&type=template&id=622c61f9"
import script from "./Size.vue?vue&type=script&lang=js"
export * from "./Size.vue?vue&type=script&lang=js"
script.render = render

export default script